// extracted by mini-css-extract-plugin
export default {"projectItem":"ProjectItem_projectItem__UacxB","projectImage":"ProjectItem_projectImage__zBIo0","projectDetails":"ProjectItem_projectDetails__MgrcP"};